import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from '@/core/router';
import './styles/global.css';

/**
 * Điểm vào duy nhất, dùng cho CẢ hai phía: lúc build nó chạy trong Node để prerender từng route
 * ra HTML, lúc chạy trên trình duyệt nó hydrate lại chính cây route đó. Một nguồn route, nên
 * bản tĩnh và bản tương tác không thể lệch nhau.
 */
export const createRoot = ViteReactSSG({ routes });
